import { API_TIMEOUT_ERROR, UNKNOWN_ERROR_MESSAGE } from './constants';

class ApiTimeoutError extends Error {
  constructor(code = null, message = UNKNOWN_ERROR_MESSAGE, status = null) {
    super();

    this.name = API_TIMEOUT_ERROR;
    this.message = message;
    this.code = code;
    this.status = status;
  }
}

export default ApiTimeoutError;



// WEBPACK FOOTER //
// ./app/sdk/common/ApiTimeoutError.js